// Alle iconen op een plek, als lijntekeningen. Bewust geen emoji: die zien er op elk
// apparaat anders uit en schalen niet mee met de tekst. De paden zelf staan in icoonpaden.ts.

import { ICOONPADEN, type IcoonNaam } from "./icoonpaden.ts";

export { ICOONPADEN };
export type { IcoonNaam };

export function Icoon({ naam, grootte = 17 }: { naam: IcoonNaam; grootte?: number }) {
  return (
    <svg
      width={grootte}
      height={grootte}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <path d={ICOONPADEN[naam]} />
    </svg>
  );
}
